/* istanbul ignore file */
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useAssignmentService } from 'domain/shared/assignment';

const AssignmentContext = ({ permissionToCheck, children, id }: SecurityContextCommonProps) => {
  const { getPermissions } = useAssignmentService();
  const CONTEXT_NAME = 'ASSIGNMENT_CONTEXT';

  return (
    <SecurityContextTemplate
      id={id}
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={CONTEXT_NAME}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default AssignmentContext;
